<template>
    <!--选择随机题型-->
    <div class="choose-ques-container">
        <img src="@/assets/img/admin/choose-ques.png" alt="empty"/>
        <div class="font-medium font-size16" style="margin: 57px 0 40px">满足条件试题数量：
            <span class="c-F33737 font-size30 font-weight">{{quesNum}}</span>
        </div>
        <label for="zj-choose-ques-input" v-show="quesNum > 0">
            选取试题数量：
            <el-input-number :value="value" placeholder="请输入"
                             @input="onInput"
                             :controls="false"
                             :min="1"
                             :max="quesNum"
                             id="zj-choose-ques-input"
                             :precision="0"></el-input-number>
        </label>
    </div>
</template>

<script>
export default {
    name: "ChooseQues",
    props: {
        value: {
            type: [String, Number]
        },
        quesNum: {
            type: Number,
            default: 0
        }
    },
    methods: {
        onInput (val) {
            this.$emit("input", val)
        }
    }
}
</script>

<style scoped lang="less">
.choose-ques-container {
    display: flex;
    justify-content: center;
    padding: 60px;
    flex-direction: column;
    align-items: center;

}
</style>
